import { createTheme } from '@uhg-abyss/web/tools/theme';

export const colorTokens = {
  interactivePrimary: '#0C55B8',
  interactiveNav: '#002677',
  surfaceHeroHover: '#D9F6FA',
  surfaceDisabled: '#EEEEEE',
  linkDefault: '#0366d6',
  textPrimary: '#000000',
  textSecondary: '#5A5A5A',
  textDisabled: '#999999',
  textOnDark: '#FFFFFF',
  codeAccent: '#E01A76',
  surfaceWhite: '#FFFFFF',
  surfaceErrorSubtle: '#FCF0F0',
  buttonPrimaryLegacy: '#1b6ec2',
  buttonPrimaryLegacyBorder: '#1861ac',
  statusError: '#C40000',
  statusSuccess: '#007000',
} as const;

export const globalOverrides = {
  a: {
    color: '$linkDefault',
  },
  code: {
    color: '$codeAccent',
  },
  '.btn-primary': {
    color: '$textOnDark',
    backgroundColor: '$buttonPrimaryLegacy',
    borderColor: '$buttonPrimaryLegacyBorder',
  },
  '.abyss-page-header-logo-title': {
    color: '$textSecondary !important',
  },
  '.abyss-page-header-logo': {
    color: '$textSecondary !important',
  },
  '.abyss-nav-menu-item-title': {
    color: '$interactiveNav !important',
  },
} as const;

export const appTheme = createTheme('optum', {
  theme: {
    colors: colorTokens,
  },
  css: globalOverrides,
});
